import type { ItemStoreEvents } from "../itemStore.store";
import { sceneTextStoreHooks } from "../sceneText/sceneTextStoreHooks";
import { sceneShapeStoreHooks } from "../sceneShape/sceneShapeStoreHooks";
import { sceneChartStoreHooks } from "../sceneChart/sceneChartStoreHooks";
import { sceneMediumStoreHooks } from "../sceneMedium/sceneMediumStoreHooks";
import { sceneLayerStoreHooks } from "../sceneLayer/sceneLayerStoreHooks";
import { sceneGroupStoreHooks } from "../sceneGroup/sceneGroupStoreHooks";
import { sceneElementStoreHooks } from "../sceneElement/sceneElementStoreHooks";
import type { SceneNodeType } from "./SceneNodeData";
import type { SceneNodeItem } from "./SceneNodeItem";

export const sceneNodeStoreHooks: { [type in SceneNodeType]: Partial<ItemStoreEvents<SceneNodeItem<type>>> } = {
  "text": sceneTextStoreHooks,
  "shape": sceneShapeStoreHooks,
  "chart": sceneChartStoreHooks,
  "medium": sceneMediumStoreHooks,
  "layer": sceneLayerStoreHooks,
  "group": sceneGroupStoreHooks,
  "element": sceneElementStoreHooks
};
